import { FC } from "preact/compat";
import { AttachmentProps } from "./interfaces";

const IMAGE_TYPES = [
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/webp",
    "image/svg+xml",
];

const Attachment: FC<AttachmentProps> = ({ media }) => {
    const isImage = IMAGE_TYPES.includes(media.type);

    return (
        <div className="relative h-[140px] border border-gray-200 rounded-lg">
            {isImage && (
                <img
                    className="object-cover w-full h-full rounded-lg"
                    alt={media.name}
                    src={media.url}
                />
            )}
            <div className="absolute bottom-0 left-0 right-0 py-1 text-xs text-center text-white rounded-b-lg bg-black/50">
                {media.name}
            </div>
        </div>
    );
};

export default Attachment;
